import React, { useState } from "react";
import { TasksAPI } from "@/api/tasks";
import QueryRequest from "@/components/QueryRequest";
import { ORDERS_NS } from "@/i18n/ns";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import BottomSheet from "_c/BottomSheet";
import TaskItem from "_c/modules/tasks/TaskItem";
import { Spin } from "_c/preloader";
import TaskEditorModal from "_c/Modals/task-editor/modal";
import ClientProfileModal from "_c/Modals/client-profile-modal";
import { TasksCacheService } from "@/services/tasks/cache";
import ms from "ms";
import WithNoSSR from "@/components/HOC/withNoSSR";

const SingleTaskViewer = ({
  isOpen,
  onClose,
  task,
  saloonOnly,
  enablePortal,
  zIndex = 1,
}) => {
  return (
    <BottomSheet
      zIndex={zIndex}
      disablePortal={!enablePortal}
      defaultHeight={window.innerHeight * 0.75}
      header={<div />}
      isOpen={isOpen && task}
      onClose={onClose}
    >
      <div
        css={`
          color: var(--font-color-main);
          padding: 10px;
        `}
      >
        <Main task={task} saloonOnly={saloonOnly} onClose={onClose} />
      </div>
    </BottomSheet>
  );
};

const Main = ({ task: taskId, saloonOnly, onClose }) => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [clientProfile, setClientProfile] = useState(null);
  const { t, ready } = useTranslation(["common", ORDERS_NS, "errors"], {
    useSuspense: false,
  });
  const taskQuery = useQuery(
    TasksCacheService.buildSingleTaskQueryKey(taskId),
    () => TasksAPI.findById(taskId).then(({ data }) => data),
    {
      staleTime: ms("1 minute"),
      enabled: !!taskId,
    }
  );
  if (!ready) return <Spin />;
  const task = taskQuery.data;
  return (
    <>
      <QueryRequest query={taskQuery}>
        {task && (
          <TaskItem
            openEditor={() => setIsEditorOpen(true)}
            t={t}
            openClientProfile={setClientProfile}
            onTaskRemove={onClose}
            task={task}
          />
        )}
      </QueryRequest>
      <TaskEditorModal
        task={task}
        mode={task?.custom ? "custom" : "normal"}
        onClose={() => setIsEditorOpen(false)}
        masterId={task?.master}
        isOpen={isEditorOpen}
        saloonOnly={saloonOnly}
      />
      <ClientProfileModal
        onClose={() => setClientProfile(null)}
        isOpen={!!clientProfile}
        client={clientProfile}
        disableActions
        t={t}
      />
    </>
  );
};

export default WithNoSSR(SingleTaskViewer);
